import React, { useEffect, useState } from "react";
import { Checkbox, IconButton, Tooltip, Chip, Button, TextField, Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, 
  Backdrop,
  CircularProgress,
  Select,
  MenuItem,
  ListItemText,
  OutlinedInput,
  Grid,
  Container} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { AxiosRequestConfig } from "axios";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import requestMissingContexts, { determineConfig, determineConfigLong } from "../utils/GetContext";
import { useHistory } from "react-router-dom";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { AxiosError, AxiosResponse } from "axios";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import { prettyPrintKPI } from "../components/request/CardKPIReco";
import {
  RestAPiReceipt,
  RestApiDefaultColumnOptions,
  GetDefaultColumnOptions,
  detectFilterChanges,
  getCustomerListData
} from "../utils/CustomerListPageHelper";
import Fuse from "fuse.js";
import { Brightness1, Ballot, ArrowDownward, ArrowUpward, Clear, RotateLeft, Bookmarks, SearchOff, Search, StarRateSharp } from "@mui/icons-material";

import PageInPage from "../componentUtils/PageInPage";
import RecommendationComponent from "../components/request/Recommend";
import VendPrimeRequest from "./VendPrime/VendPrimeRequest";
import {
  GridFilterItem,
  GridFilterInputValue,
  DataGridPro,
  LicenseInfo,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridLinkOperator,
  GridSortModel,
  MuiEvent,
  GridColumnResizeParams,
  GridColDef,
  GridFilterModel,
  GridEventListener,
  useGridApiRef
} from "@mui/x-data-grid-pro";
import { formatDate, tryParseIntOrZero } from "../utils/Formatter";
import { GetStatusIcon, GetStatusBadge } from "../components/request/requestUtils";
import { getSettingsData,saveSettingsData} from "../utils/GetSettingsData";
import { getSalesOfficesAndRoutes } from "../utils/GetPlanning";
import { getSalesOffices } from "../utils/GetAdminSettings";
import { forEach } from "lodash";
import { color } from "d3";
export interface TableAbstractionInputs {
  settingsKey:string;
  title?: string;
  // options?: TableAbstractionOptions;
  // data?: any[];
  // columns: TableAbstractionColumn[];
  error?:boolean;
  loading?:boolean;
  handleSaveProps?: any;
}

// eslint-disable-next-line max-len
LicenseInfo.setLicenseKey("55a5960678d2f17e42032f031b42392aTz0xMjY1OTgsRT0xODA4MDQ5NjAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y");

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @type {*}
 */
const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    checkbox: {},
    root: {
      flexGrow: 1,
      marginBottom: theme.spacing(2)
    },
    dropdown: {
      marginTop: theme.spacing(2),
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center"
    },
    rootSpacing: {
      marginBottom: theme.spacing(2)
    },
    centerDiv: {
      textAlign: "center"
    },
    materialTable: {
      fontFamily: theme.typography.fontFamily
    },
    spaceAll: {
      margin: theme.spacing(2),
      marginLeft: theme.spacing(0)
    },
    iconRed: {
      color: theme.palette.statusRed.main,
      fontSize: 13
    },
    iconButton: {
      padding: 0,
      margin: 0
    },
    iconYellow: {
      color: theme.palette.statusYellow.main,
      fontSize: 13
    },
    iconGreen: {
      color: theme.palette.statusGreen.main,
      fontSize: 13
    },
    iconDisabled: {
      color: "LightGray",
      fontSize: 13
    },
    downTrend: {
      color: theme.palette.statusRed.main
    },
    upTrend: {
      color: theme.palette.statusGreen.main
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    modalGrid: {
      marginTop: theme.spacing(2),
      alignItems: "center",
      justifyContent: "center",
      top: `50%`,
      left: `50%`
    },
    modalTitle: {
      color: theme.palette.primary.main
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2)
    },
    ulNoBullets: {
      listStyleType: "none",
      padding: 0,
      margin: 0
    }
  }));

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {any[]} arr
 * @param {number} old_index
 * @param {number} new_index
 * @returns {{}}
 */
function arrayMove(arr: any[], old_index: number, new_index: number): any {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
}

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {boolean} isChecked
 * @param {*} [handleClick=() => {}]
 * @returns {*}
 */
function ReadOnlyCheckBox(isChecked: boolean, handleClick: any = () => {}): any {
  // const classes = useStyles();
  return (
    <Checkbox checked={isChecked} name="active" color="primary" onClick={handleClick} />
    // <Checkbox checked={isChecked} name="active" color="primary"  />
  );
}

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {(number | undefined)} value
 * @param {?number} [red]
 * @param {?number} [yellow]
 * @returns {*}
*/
// function TrafficLightPercentage(value: number | undefined, red?: number, yellow?: number): any {
  
//   const Styles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     iconGreen: {
//       color: theme.palette.statusGreen.main,
//       fontSize: 13
//     },
//     iconDisabled: {
//       color: "LightGray",
//       fontSize: 13
//     },
//     iconRed: {
//       color: theme.palette.statusRed.main,
//       fontSize: 13
//     },
//     iconYellow: {
//       color: theme.palette.statusYellow.main,
//       fontSize: 13
//     }
//   }));

//   const classes = Styles();
  
//   let cName = value ? classes.iconGreen : classes.iconDisabled;
//   if (value && value <= (red || 50)) {
//     cName = classes.iconRed;
//   } else if (value && value <= (yellow || 70)) {
//     cName = classes.iconYellow;
//   }
//   return (
//     <div>
//       <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
//     </div>
//   );
// }

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {*} classes
 * @param {string} kpiName
 * @param {number} curVal
 * @param {number} predVal
 * @returns {*}
 */
function PrintKPI(classes: any, kpiName: string, curVal: number, predVal: number): any {
  if (curVal < predVal) {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
        <ArrowUpward className={classes.upTrend} fontSize="small" />
        {prettyPrintKPI(kpiName, predVal)}
      </li>
    );
  } else if (curVal > predVal) {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
        <ArrowDownward className={classes.downTrend} fontSize="small" />
        {prettyPrintKPI(kpiName, predVal)}
      </li>
    );
  } else {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
      </li>
    );
  }
}

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @export
 * @returns {*}
 */


export default function VendPrimePage(props: TableAbstractionInputs): any {
  const classes = useStyles();
  const gridApiRef = useGridApiRef();
  const history = useHistory();
  const [apidata, setApidata] = React.useState<RestAPiReceipt>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "4100");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [defaultColumnOptions, setDefaultColumnOptions] = React.useState<RestApiDefaultColumnOptions>({});
  const [codes, setCodes] = React.useState<any>();
  const [confirmResetFilter, setConfirmResetFilter] = React.useState<boolean>(false);
  const [filterLS, setFilterLS] = useLocalStorage<GridFilterModel>("SETTINGS.CLP_filters", {
    items: [],
    linkOperator: GridLinkOperator.And
  });
  const [sortLS, setSortLS] = useLocalStorage<GridSortModel>("SETTINGS.CLP_sort", []);
  const [columnOrder, setColumnOrder] = useLocalStorage<string[]>("SETTINGS.CLP_column_order", []);
  const [columnSizeLS, setColumnSizeLS] = useLocalStorage<{
    [key: string]: number;
  }>("SETTINGS.CLP_colsize", {});
  const [displayLS, setDisplayLS] = useLocalStorage<{ [key: string]: boolean }>("SETTINGS.CLP_displayableColumns", {
    master_route: true,
    name1: true,
    name3: true,
    active: true,
    equipment_num: true,
    bank_name: true,
    customer_num: true,
    recommend: true,
    asset_num: true,
    errors: true,
    equipment_location: true,
  });
  const [madeChange, setMadeChange] = useState(false);
  const [failedPullingData, setFailedPullingData] = useState(false);

  const [showReco, setShowReco] = useState<any>({});
  const [showTicket, setShowTicket] = React.useState<
    | {
        requestNum: number;
        salesOffice: string;
        customerNum: string;
        customerName: string;
      }
    | undefined
  >();
  const [page, setPage] = useLocalStorage<number>("SETTINGS.CLP_PageNumber", 0);
  const [pageRowCount, setPageRowCount] = useLocalStorage<number>("SETTINGS.CLP_PageRowCount", 50);
  const [omniSearch, setOmniSearch] = useState<OSearch>({enabled:false});
  const key = (props.settingsKey)||'GTA';
  const rowData = (apidata && apidata.out && apidata.out.length > 0 && apidata.out) || [];
  const reorderingRef = React.useRef({
    isDragging: false,
    oldIndex: 0,
    targetIndex: 0
  });
  const [showLoader,setShowLoader]=useState(false);

  const [plantList, setPlant] = useState([]);
  const [plantName, setPlantName] = React.useState<string[]>([]);
  const [open, setOpen] = React.useState<boolean>(false);
  const [plantModified, setPlantModified] = React.useState<boolean>(true);
  interface OSearch {
    enabled:boolean, // does one or more column allow this type of search? 
    searching?:boolean, // is the user searching? 
    text?:string // what is the user searching for?
}

  //defaultColumnOptions
  const SetCurrentColumnConfig = (option: string) => {
    if (defaultColumnOptions[option]) {
      setFilterLS(defaultColumnOptions[option].CLP_filters);
      setDisplayLS(defaultColumnOptions[option].CLP_displayableColumns);
      setColumnOrder(defaultColumnOptions[option].CLP_column_order);
    }
  };

  const defaultColumnOptionList = Object.keys(defaultColumnOptions);
  const CustomToolbar = (title?:string, save?:any) => {
    let timeout: NodeJS.Timeout;
    let text = '';
    
    function enableSearch(searching:boolean){
        setOmniSearch({...omniSearch,searching,text:undefined})
    }
    function setSearch(ce:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>){
        text = ce.target.value || ''
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setOmniSearch({...omniSearch,text})
        }, 3000)
    }
    const handleSave = () => {
        save.handleSave()
    } 
    return (
      <React.Fragment>
      <GridToolbarContainer key={key+"toolbar"}>
                  {
                  // (omniSearch.enabled)?(
              (omniSearch.searching)?(
                  <div 
                      key={key+"omniSearchDiv"}
                      style={{verticalAlign: "middle"}}
                  >
                      <TextField
                          key={key+"omniSearchTextField"}
                          fullWidth={false}
                          size="small"
                          variant="outlined"
                          defaultValue={omniSearch.text}
                          onChange={setSearch}
                          onKeyPress={(kp)=>{
                                if(kp.code === 'Enter'){
                                    clearTimeout(timeout);
                                    setOmniSearch({...omniSearch,text})
                                }
                          }}
                      />
                      <Button
                          key={key+"omniSearchButton"}
                          color="primary"
                          size="small"
                          onClick={() => enableSearch(false)}
                      >
                              <SearchOff/>
                      </Button>
                  </div>
              ):(
                  <Button
                      color="primary"
                      size="small"
                      onClick={() => enableSearch(true)}
                  >
                          <Search /> Search
                  </Button>
              )
          // ):(<div/>)
          }
        {defaultColumnOptionList.length === 1 ? (
          // TODO: add drop down if we have multiple options here. Currently do not.
          <Button color="primary" size="small" onClick={() => SetCurrentColumnConfig(defaultColumnOptionList[0])}>
            <Bookmarks /> {defaultColumnOptionList[0]}
          </Button>
          
        ) : (
          <div />
        )}
        <GridToolbarColumnsButton nonce={undefined} onResize={undefined} onResizeCapture={undefined} />
        
        <GridToolbarFilterButton nonce={undefined} onResize={undefined} onResizeCapture={undefined}  />
        
        <Button
          color="primary"
          size="small"
          onClick={() => {
          setConfirmResetFilter(true)
          }
          }
        >
          <Clear /> Clear Filters
        </Button>
        <GridToolbarDensitySelector nonce={undefined} onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarExport />
          <Select
                  labelId="Plant"
                  multiple
                  onChange={selectedPlant}
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={plantName}
                  renderValue={(selected) => selected.join(', ')}
                  style={{  height: "55px", width: "200px",marginLeft: "auto"  }}
                >
                  {plantList.map((item:any) => (
                    <MenuItem value={item?.code}>
                      <Checkbox checked={plantName.indexOf(item?.code) > -1} />
                      <ListItemText primary={item?.code+'-'+ item?.text} />
                    </MenuItem>
                  ))} 
          </Select>
      </GridToolbarContainer>
  <Dialog
open={confirmResetFilter}
onClose={()=>setConfirmResetFilter(false)}
>
<DialogTitle>Confirm Reset Filters</DialogTitle>
<DialogContent>
  <DialogContentText>
    Column filters will be reset. Are you sure you wish to continue ?
  </DialogContentText>
</DialogContent>
<DialogActions>
  <Button onClick={()=>{handleResetFilters(); setConfirmResetFilter(false);}} color="primary">
    Yes
  </Button>
  <Button onClick={()=>{setConfirmResetFilter(false);}} color="primary" autoFocus>
    No
  </Button>
</DialogActions>
  </Dialog>
      </React.Fragment>
    );
    
  };

  async function refreshRequest(customerNum: string) {
    const configReq: AxiosRequestConfig = {
      method: "GET",
      params: {
        clientId,
        salesOrg,
        customerNum
      },
      url: `${BASE_URL}/api/request`
    };

    return await AXIOS_INSTANCE(configReq)
      .catch((ae: AxiosError) => {})
      .then((res: AxiosResponse<any> | void) => {
        if (res && res.status < 400 && apidata) {
          const indx = apidata.out.findIndex((c) => c.customer_num === customerNum);
          if (indx >= 0) {
            let cur = apidata.out[indx];
            const req = res.data.request;
            cur = {
              ...cur,
              request_num: req.requestNum,
              sap_request_number: req.sapRequestNumber,
              request_status: req.requestStatus,
              requested_dt: req.requestedDt,
              request_max_dt: req.requestedDt
            };
            setApidata({
              ...apidata,
              out: [...apidata.out.slice(0, indx), cur, ...apidata.out.slice(indx + 1)]
            });
          } else {
            console.error(`Unable to find index(${indx}) for customerNum(${customerNum}). can not update ticket data.`);
          }
        }
      });
  }
useEffect(() => {
  //if (isLoaded) return;
    if(salesOrg){

         getSettingsData(salesOrg).then((v) => {
         // setSettingsTableData(v?.data);
         // For Displaying columns
  
          for (let i=0;i<v?.data?.length;i++){
          if(v?.data[i]?.colKey === `${key}_displayableColumns`){
            setDisplayLS(JSON.parse(v?.data[i]?.colVal));
          }

          // For filters

          if(v?.data[i]?.colKey === `${key}_filters`){
              setFilterLS(JSON.parse(v?.data[i]?.colVal));
          }

          // For coloumn order

          if(v?.data[i]?.colKey === `${key}_column_order`){
              setColumnOrder(JSON.parse(v?.data[i]?.colVal));
          }

          // For column size

          if(v?.data[i]?.colKey === `${key}_colsize`){
              setColumnSizeLS(JSON.parse(v?.data[i]?.colVal));
          }

          //

          if(v?.data[i]?.colKey === `${key}_sort`){
              setSortLS(JSON.parse(v?.data[i]?.colVal));
          }

         }
  
       });
 
     Promise.all([getSalesOfficesAndRoutes(salesOrg),getSalesOffices(salesOrg,true)]).then((v) => {
      if(v[1]){
         let plants:any=v[1]; 
         setPlant(plants)
      }
      if(v[0]){
        const r_so:any = v[0].plants;
        if(r_so.length>0){
          let value=r_so[0]?.plant;
          setPlantName(typeof value === "string" ? value.split(",") :value ); 
          getCustomerListByPlant([value])
        }else{
          const p_lants:any = v[1]
          if(p_lants.length>0){
            let value=p_lants[0]?.code;
            setPlantName(typeof value === "string" ? value.split(",") :value ); 
            getCustomerListByPlant([value])
        }
      }
    }
     
    });
      }
  }, []);

  useEffect(() => {
    const handleColumnHeaderDragEnd: GridEventListener<"columnHeaderDragEnd"> = (
      params
    ) => {
      setColumnOrder(arrayMove(columnOrder, reorderingRef.current.oldIndex, reorderingRef.current.targetIndex));
      saveTxSettingsData(JSON.stringify(columnOrder),'_column_order');
      reorderingRef.current = {
        isDragging: false,
        oldIndex: 0,
        targetIndex: 0
      };
    };

    // The `subscribeEvent` method will automatically unsubscribe in the cleanup function of the `useEffect`.
    return gridApiRef.current.subscribeEvent(
      "columnHeaderDragEnd",
      handleColumnHeaderDragEnd
    );
  }, [gridApiRef]);

  useEffect(() => {
    if (!apidata) {
      requestMissingContexts([
        "FSVSUBTRADECHANNEL",
        "FSVTRADECHANNEL",
        "SALESOFFICES",
        "PLANTS",
        "TRADECHANNEL",
        "TRADENAMES",
        "BRAND",
        "PACKSIZE",
        "PACKTYPE",
        "FLAVOUR",
        "BEVERAGECATEGORY",
        "vp_req_status"
      ]).then((v) => {
        setCodes(v);
      });

      GetDefaultColumnOptions(salesOrg).then((v) => {
        setDefaultColumnOptions(v.data);
      });
    } 
     if (madeChange) {
      getCustomerListByPlant(plantName).then(res=>{
        setMadeChange(false);
      })
    }
  }, [madeChange]);

  const allFilterChoice = {
    code: "",
    text: "All",
    text_long: "All"
  };


  

const  handleResetFilters = () => {
  
    setFilterLS({ items: [], linkOperator: GridLinkOperator.And })
    saveTxSettingsData(JSON.stringify({ items: [], linkOperator: GridLinkOperator.And }), '_filters');
      for (let index = 0; index < filterLS.items .length; index++) {
        const  element= filterLS.items [index];
          switch (element.operatorValue) {
            case "brand_eq":
              setShowLoader(true)
              setMadeChange(true)
              break;
            case "pack_size_eq":
              setShowLoader(true)
              setMadeChange(true)
              break;
            case "pack_type_eq":
              setShowLoader(true)
              setMadeChange(true)
              break;
            case "flavor_eq":
              setShowLoader(true)
              setMadeChange(true)
              break;
            case "beverage_category_eq":
              setShowLoader(true)
              setMadeChange(true)
              break;
          } 
      }
    
  }

  const handleFilterModelChange = (params: GridFilterModel) => {
    setFilterLS(params);
    saveTxSettingsData(JSON.stringify(params),'_filters');
    if (params && detectFilterChanges(params.items, filterLS.items)) {
      const newBackendFilters = params.items.filter((fmi: GridFilterItem) => fmi && (fmi.columnField || "").startsWith("BACKEND_"));
      const backendFilters = filterLS.items.filter((fmi: GridFilterItem) => fmi && (fmi.columnField || "").startsWith("BACKEND_"));
      if (detectFilterChanges(backendFilters, newBackendFilters)) {
        setApidata(undefined);
        setMadeChange(true);
      }
    }
  };

  const handleColumnModelChange = (params: any) => {
    if (JSON.stringify(params) !== JSON.stringify(displayLS)){
      setDisplayLS(params);
      saveTxSettingsData(JSON.stringify(params), '_displayableColumns');
    }
  };
  const handleSortModelChange = (params: GridSortModel) => {
    //console.log("checkParams:",params);
    /**
     * Only update state if there has actually been a change.
     * This fixes a maximum call stack size error.
     */
    if (JSON.stringify(params) !== JSON.stringify(sortLS)) setSortLS(params);
    saveTxSettingsData(JSON.stringify(params),'_sort');
  };

  const handleColumnResize = (params: GridColumnResizeParams) => {
    // let col:string = params.colDef.field;
    // let width:number = params.width;
    // let cs = {...columnSizeLS};
    // cs[col] = width;
    // setColumnSizeLS(cs);
    columnSizeLS[params.colDef.field] = params.width;
    setColumnSizeLS(columnSizeLS);
    saveTxSettingsData(JSON.stringify(columnSizeLS),'_colsize');
  };

  const getSortedColumns = () => {
    const cols = getColumns();

    let colSrt = columnOrder;
    const colNamesAll = cols.map((c) => c.field);
    const colNamesNew = colNamesAll?.filter((cn) => {
      return -1 === columnOrder?.findIndex((co) => co === cn);
    });
    if (colNamesNew.length > 0) {
      colSrt = colSrt?.concat(colNamesNew);
      setColumnOrder(colSrt);
    }

    const getSortIndex = (field: string) => {
      return colSrt?.findIndex((co) => co === field);
    };
    const sortFunction = (a: GridColDef, b: GridColDef) => {
      return getSortIndex(a.field) - getSortIndex(b.field);
    };
    return cols.sort(sortFunction);
  };

  function saveTxSettingsData(value:string, columnName:string){
    const colKey = (key+columnName);
    if(salesOrg){
    saveSettingsData(salesOrg,colKey,value).then((v) => {
      });
    }
}

  const defaultColumnConfig = (field?: string, width?: number) => {
    let ret: any = {
      disableColumnMenu: true
    };
    if (field) {
      ret = {
        ...ret,
        field,
        hide: !displayLS[field],
        width: columnSizeLS[field] || width || 140
      };
    }
    return ret;
  };
  const getColumns = () => {
    const cols: GridColDef[] = [
      {
        ...defaultColumnConfig("customer_num"),
        headerName: "Customer #",
        searchable: true,
        renderCell: (params) => (
          <Chip
            label={params.value as any}
            variant="outlined"
            size="small"
            clickable={true}
            onClick={() => window.open(`/customer/${params.value as any}`, "_blank")}
          />
        )
      },
      {
        ...defaultColumnConfig("name1"),
        headerName: "Customer Name"
      },
      {
        ...defaultColumnConfig("name3"),
        headerName: "Location"
      },
      {
        ...defaultColumnConfig("sales_office"),
        headerName: "Sales Office",
        renderCell: (params) =>
          `${params.value} - ${determineConfigLong(codes, "SALESOFFICES", params.value!.toString())}`,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "sales_office",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.sales_office
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text}
                    </option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "sales_office_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.sales_office
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text}
                    </option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("delivering_plant"),
        headerName: "Delivery Plant",
        renderCell: (params) =>
        `${params.value} - ${determineConfigLong(codes, "PLANTS", params.value!.toString())}`,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "delivering_plant",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.delivering_plant
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text} 
                    </option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "delivering_plant_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.delivering_plant
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text} 
                    </option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("master_route"),
        headerName: "Route",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "route",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.master_route.map((v: any) => (
                  <option value={v.text}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "route_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.master_route.map((v: any) => (
                  <option value={v.text}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("trade_name"),
        headerName: "Trade Name",
        renderCell: (params) => determineConfigLong(codes, "TRADENAMES", params.value!.toString()),
        filterable: false
      },
      {
        ...defaultColumnConfig("trade_channel"),
        headerName: "Trade Channel",
        renderCell: (params) => determineConfig(codes, "FSVTRADECHANNEL", params.value!.toString()) || "",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "trade_channel",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.trade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "trade_channel_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.trade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("subtrade_channel"),
        headerName: "Subtrade Channel",
        renderCell: (params) => determineConfig(codes, "FSVSUBTRADECHANNEL", params.value!.toString()),
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "subtrade_channel",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.subtrade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "subtrade_channel_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.subtrade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("active", 120),
        headerName: "Active",
        type: "boolean",
        renderCell: (params) => ReadOnlyCheckBox(params.value as any)
      },
      {
        ...defaultColumnConfig("suspension_begin_days"),
        headerName: "Suspension",
        description: "Suspension Status",
        renderCell: ({ value }) => {
          if (typeof value === "number") {
            if (value <= 0) {
              return (
                <div>
                  <Brightness1 fontSize="small" className={classes.iconRed} /> Suspend
                </div>
              );
            } else {
              return (
                <div>
                  <Brightness1 fontSize="small" className={classes.iconYellow} /> Future
                </div>
              );
            }
          } else return "";
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (filterItem.value === "S") return (params.value || 1) <= 0;
                if (filterItem.value === "F") return (params.value || 0) > 0;
                if (filterItem.value === "N") return params.value === null;
                return true;
              };
            },
            label: "is",
            value: "Suspension",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value="N">None</option>
                <option value="F">Future</option>
                <option value="S">Suspend</option>
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("equipment_num", 85),
        headerName: "EQP",
        description: "Has Equipment Assigned",
        type: "boolean",
        renderCell: ({ value }) => ReadOnlyCheckBox((value as any) && (value as any).length > 0),
        filterable: true
      },
      {
        ...defaultColumnConfig("asset_num"),
        headerName: "Asset #",
        filterable: true
      },
      {
        ...defaultColumnConfig("equipment_model"),
        headerName: "Model",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "model",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_model
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "model_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_model
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("equipment_location", 200),
        headerName: "Equipment Location",
        valueGetter: (params) => params.value.trim()
      },
      {
        ...defaultColumnConfig("equipment_status", 120),
        headerName: "EQP STS",
        description: "Equipment Status",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "eqp_status",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_status
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "eqp_status_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_status
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("sub_serial_num"),
        headerName: "Serial Number",
        description: "Serial Number",
      },
      {
        ...defaultColumnConfig("aml_id"),
        headerName: "AML",
        description: "Auth Material List Id",
      },
      {
        ...defaultColumnConfig("eml_id"),
        headerName: "EML",
        description: "Auth Material Exckusion List Id",
      },
      {
        ...defaultColumnConfig("settlement_method", 90),
        headerName: "Stl M",
        description: "Settlement Method",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return `${params.value}` === `${filterItem.value}`;
              };
            },
            label: "equals",
            value: "stl_method",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.settlement_method
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("bank_name", 90),
        headerName: "Bank",
        renderCell: (params) => {
          if (params.value) {
            let custList: JSX.Element = <div />;
            const mdBankCustomers: any[] = apidata
              ? apidata.banks.find((b: any) => b.guid === params.row.bank_guid)?.mdBankCustomers || []
              : [];
            if (mdBankCustomers && mdBankCustomers.length > 0) {
              custList = (
                <div>
                  {mdBankCustomers.map((bc: any) => (
                    <div>
                      {bc.customerNum} {bc.mdCustomer.name1}
                    </div>
                  ))}
                </div>
              );
            }
            return (
              <Tooltip
                title={
                  <React.Fragment>
                    {`Bank: ${params.value}`}
                    <br />
                    {custList}
                  </React.Fragment>
                }
              >
                {/** Adding onclick event to bank checkbox for navigating to
                 * bank tab in customer list
                 */}
                {ReadOnlyCheckBox(true, () => history.push(`/customer/${params.row.customer_num as any}`, 1))}
              </Tooltip>
            );
          } else {
            {
              /** Adding onclick event to bank checkbox for navigating to
               * bank tab in customer list
               */
            }
            return ReadOnlyCheckBox(false, () => history.push(`/customer/${params.row.customer_num as any}`, 1));
          }
        }
      },
      {
        ...defaultColumnConfig("errors", 95),
        headerName: "Errors",
        type: "boolean",
        description: "Inconsistency Errors",
        renderCell: (params) => {
          const checked = params.row.customererrors || params.row.materialerrors;
          return ReadOnlyCheckBox(checked);
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if ("ANY" === filterItem.value) {
                  return params.row.customererrors || params.row.materialerrors;
                } else if ("CST" === filterItem.value) {
                  return params.row.customererrors;
                } else if ("MAT" === filterItem.value) {
                  return params.row.materialerrors;
                }
                return true;
              };
            },
            label: "has",
            value: "errors_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={"ANY"}>Error</option>
                <option value={"CST"}>Customer Error</option>
                <option value={"MAT"}>Material Error</option>
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if ("ANY" === filterItem.value) {
                  return !(params.row.customererrors || params.row.materialerrors);
                } else if ("CST" === filterItem.value) {
                  return !params.row.customererrors;
                } else if ("MAT" === filterItem.value) {
                  return !params.row.materialerrors;
                }
                return true;
              };
            },
            label: "has no",
            value: "errors_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={"ANY"}>Error</option>
                <option value={"CST"}>Customer Error</option>
                <option value={"MAT"}>Material Error</option>
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        ...defaultColumnConfig("effective_fill_rate", 125),
        headerName: "PFR@OOS",
        type: "number",
        description: "Projected Fill Rate @ Out Of Stock",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("last_fill_rate", 125),
        headerName: "LFR",
        description: "Last Fill Rate",
        type: "number",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("average_fill_rate", 125),
        headerName: "AFR",
        description: "Average Fill Rate",
        type: "number",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("settlement_count", 90),
        headerName: "STLs",
        description: "Settlement Count",
        type: "number"
      },
      {
        ...defaultColumnConfig("last_visit_dt"),
        headerName: "Last Visit",
        type: "date"
      },
      {
        ...defaultColumnConfig("last_visit_since"),
        headerName: "Last Visited Since",
        type: "date",
        valueGetter: (props) => {
          if(props?.row?.last_visit_dt){
              const lastVisitDate: any = new Date(props?.row?.last_visit_dt);
              const todatDate: any = new Date();
              
              // One day in milliseconds
              const oneDay = 1000 * 60 * 60 * 24;
              
              // Calculate the absolute difference in milliseconds
              const diffInMs = Math.abs(todatDate - lastVisitDate);
              
              // Convert back to days and round to the nearest whole number
              return Math.round(diffInMs / oneDay);
          }
          return "";
          
      }
      },
      {
        ...defaultColumnConfig("next_visit_dt_act"),
        headerName: "Proposed Visit ❓",
         description: "Displays customer's next scheduled or confirmed visit. If no future visit is scheduled or confirmed, it displays the proposed visit date from prediction. An asterisk (*) indicates that the displayed date comes from the next scheduled or confirmed visit.",
         renderCell: (props) => {
          const returnDate: string = props?.row?.next_visit_dt_act;
          if(props?.row?.latest_scheduled_date && new Date(props?.row?.latest_scheduled_date) > new Date() ){
              return (
                <>
                  <div>{props?.row?.latest_scheduled_date.toString()?.split("T")[0]}</div>
                  <div style={{color:"red", marginLeft:"5px", fontSize:"22px"}}>*</div>
                </>
              )
          }
          return <div>{returnDate?.toString().split("T")[0]}</div>;
        }
      },
      {
        ...defaultColumnConfig("request_num"),
        headerName: "VPR#",
        description: "VendPrime Request: Number",
        renderCell: (params) => {
          const value = params.value || "";
          if (!value || value === "") return <div />;

          if (params.row) {
            return (
              <Tooltip
                title={
                  <div>
                    Status: {determineConfig(codes, "vp_req_status", params.row.request_status) || GetStatusIcon}
                    <br />
                    Last Change: {params.row.request_max_dt ? formatDate(params.row.request_max_dt) : ""}
                  </div>
                }
              >
                <Chip
                  label={params.value}
                  variant="outlined"
                  icon={GetStatusIcon(params.row.request_status)?.icon}
                  size="small"
                  clickable={true}
                  onClick={() => {
                    setShowTicket({
                      requestNum: tryParseIntOrZero(`${value}`),
                      salesOffice: params.row.sales_office,
                      customerNum: params.row.customer_num,
                      customerName: params.row.name1
                    });
                  }}
                />
              </Tooltip>
            );
          } else {
            return <div />;
          }
        }
      },
      {
        ...defaultColumnConfig("sap_request_number", 110),
        headerName: "Ticket #",
        description: "SAP Ticket Number",
        filterable: false
      },
      {
        ...defaultColumnConfig("request_status", 200),
        headerName: "VPR Status",
        description: "VendPrime Request: Status",
        renderCell: (params) => <GetStatusBadge status={params.row.request_status} codes={codes} />,
        valueGetter: (params) => determineConfig(codes,"vp_req_status",params.row.request_status) || params.row.request_status,
      },
      {
        ...defaultColumnConfig("request_max_dt"),
        headerName: "VPR DT",
        description: "VendPrime Request: Last changed date",
        type: "date"
      },
      {
        ...defaultColumnConfig("daily_cogs", 110),
        headerName: "COGS/D",
        description: "COGS per day. Calculated at the time the last settlement reccord was processed.",
        type: "number"
      },
      {
        ...defaultColumnConfig("daily_revenue", 100),
        headerName: "Rev/D",
        description: "Revenue per day. Calculated at the time the last settlement reccord was processed.",
        type: "number"
      },
      {
        ...defaultColumnConfig("daily_net_revenue", 100),
        headerName: "Net/D",
        description: "Net revenue per day. Calculated at the time the last settlement reccord was processed.",
        type: "number"
      },
      {
        ...defaultColumnConfig("daily_opportunity", 100),
        headerName: "Op$/D",
        description:
          "Vend Prime Predicted Opportunity $ per day. This is periodically calculated by batch job, and gets recalculated when a new recomendation is run.",
        type: "number",
        renderCell: (params) => {
          if (!params.value || params.value === "") return <div />;
          const value = parseFloat((params.value || "").toString());
          if (params.row) {
            return (
              <Tooltip
                title={
                  <ul className={classes.ulNoBullets}>
                    {PrintKPI(
                      classes,
                      "Days until Stockout",
                      params.row.rrbe_days_stock_cur,
                      params.row.rrbe_days_stock_pred
                    )}
                    {PrintKPI(classes, "Vends/Day", params.row.rrbe_daily_vends_cur, params.row.rrbe_daily_vends_pred)}
                    {PrintKPI(classes, "Eff. Fill Rate", params.row.rrbe_efr_cur, params.row.rrbe_efr_pred)}
                    {PrintKPI(
                      classes,
                      "Revenue/Day",
                      params.row.rrbe_daily_revenue_cur,
                      params.row.rrbe_daily_revenue_pred
                    )}
                    {PrintKPI(classes, "GRLC/Day", params.row.rrbe_daily_grlc_cur, params.row.rrbe_daily_grlc_pred)}
                    <li>
                      Last Calculated:{" "}
                      {params.row.rrbe_last_change_dt ? formatDate(params.row.rrbe_last_change_dt) : ""}
                    </li>
                  </ul>
                }
              >
                <Chip
                  label={prettyPrintKPI("GRLC", value)}
                  variant="outlined"
                  icon={
                    value > 0 ? (
                      <ArrowUpward className={classes.upTrend} fontSize="small" />
                    ) : (
                      <ArrowDownward className={classes.downTrend} fontSize="small" />
                    )
                  }
                  size="small"
                  clickable={params.row.settlement_method === 5 && params.row.settlement_count > 1}
                  onClick={() => setShowReco(params.row)}
                />
              </Tooltip>
            );
          } else {
            return <div />;
          }
        }
      },
      {
        ...defaultColumnConfig("daily_sales", 100),
        headerName: "W-Vends/Day",
        description: "Weighted Vends Per Day. This come from the VendSmart route planning dashboard.",
        type: "number"
      },
      {
        ...defaultColumnConfig("out_of_stock"),
        headerName: "OOS",
        description: "Out of stock",
        type: "boolean",
        renderCell: (params) => {
          const checked = params.value === true;
          return ReadOnlyCheckBox(checked);
        }
      },
      {
        ...defaultColumnConfig("recommend", 100),
        headerName: "Reco",
        filterable: false,
        renderCell: (params) => {
          const customerInfo = params.row;

          if (customerInfo.settlement_method === 5 && customerInfo.settlement_count > 1 && customerInfo.equipment_status!=="INIT" && customerInfo.equipment_status!=="DISP") {
            return (
              <IconButton
                onClick={() => window.open("/vendprime/reconfig/" + customerInfo.customer_num)}
                className={classes.iconButton}
              >
                <Ballot fontSize="small" />
              </IconButton>
            );
          } else {
            return <div />;
          }
        }
      },
      {
        headerName: "Brand (filter only)",
        field: "BACKEND_brand",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "brand_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.brand
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "brand_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.brand
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        headerName: "Pack Size (filter only)",
        field: "BACKEND_pack_size",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "pack_size_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_size
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "pack_size_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_size
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        headerName: "Pack Type (filter only)",
        field: "BACKEND_pack_type",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "pack_type_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_type
                  .sort((a: any, b: any) => (a.text_long as string).localeCompare(b.text_long as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text_long}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "pack_type_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_type
                  .sort((a: any, b: any) => (a.text_long as string).localeCompare(b.text_long as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text_long}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        headerName: "Flavor (filter only)",
        field: "BACKEND_flavor",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "flavor_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.flavor
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "flavor_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.flavor
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      },
      {
        headerName: "Beverage Category (filter only)",
        field: "BACKEND_beverage_category",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "beverage_category_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.beverage_category
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "beverage_category_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.beverage_category
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            )
          }
        ]
      }
    ];
    return cols;
  };

  const fuseOptions = {
    isCaseSensitive: false,
    threshold: 0.2,
    keys:(getSortedColumns()||[]).map(c=>c?.field)
};
const fuse = new Fuse(rowData, fuseOptions);

function getFilteredRowData(){
    const searching = omniSearch.searching || false;
    const text = omniSearch.text || '';
    if(!searching || text === '' || fuseOptions.keys.length === 0)
    {
        return rowData
    }
    return fuse.search(text).map(f=>f.item) || []
}



const getCustomerListByPlant = (plant:any) => {
  return new Promise((resolve,reject) => {
    getCustomerListData(parseInt(clientId), salesOrg, filterLS, 0,plant).then((ret) => {
      setFailedPullingData(ret.failedPullingData);
      setShowLoader(false)
      setApidata(ret.apiData);
      setPlantModified(false);
      resolve(true)
    }).catch(error=>{
      reject(error)
    })

  });
  
}
  const selectedPlant = (event: any, child: any) => {
    const { target: { value } } = event;
    handleOpen();
    setPlantName([child.props.value]);
   // if (value.length >= 1) {
      // if (child.props.value === 'ALL') {
      //   setPlantName(['ALL']);
      // }
      // else {
      //   setPlantName([child.props.value]);
      // //   if (value.includes('ALL')) {
      // //     const index = value.indexOf('ALL');
      // //     value.splice(index, 1);
      // //   }
      // // if(value.length<2){
      // //   setPlantName(typeof value === "string" ? value : value);
      // // }
   
      // }
      setPlantModified(true);
   // }
  }

  const handleClose = () => {
    setOpen(false);
    if (plantModified == true) {
      setShowLoader(true)
      if (plantName.includes('ALL')) {
        let list: any = []
        plantList.forEach((element: any) => {
          if (element.code != 'ALL') {
            list.push(element.code)
          }
        });
        getCustomerListByPlant(list)
      } else {
        getCustomerListByPlant(plantName)
      }
    }
  }

const handleOpen = () => {
  setOpen(true);
}


const filteredRowData = getFilteredRowData();
  return (
    <div>
      <ResponsiveDrawer title="Customers List">
        <div className={classes.materialTable}>
          <div style={{ height: window.innerHeight - 80 }}>
            <DataGridPro
              key="customer-xgrid"
              apiRef={gridApiRef}
              filterModel={filterLS}
              sortModel={sortLS}
              error={failedPullingData ? true : undefined}
              rowsPerPageOptions={[50, 100, 250, 500, 1000]}
              onPageSizeChange={(params: any) => {
                setPageRowCount(params);
              }}
              columnBuffer={20}
              pagination
              page={page}
              onPageChange={(params: any) => {
                setPage(params);
                localStorage.setItem("SETTINGS.CLP_PageNumber", "0");
              }}
              components={{
                Toolbar: CustomToolbar
              }}
              pageSize={pageRowCount}
              onFilterModelChange={handleFilterModelChange}
              onSortModelChange={handleSortModelChange}
              onColumnVisibilityModelChange={handleColumnModelChange}
              onColumnOrderChange={(params) => {
                reorderingRef.current = reorderingRef.current.isDragging
                  ? { ...reorderingRef.current, targetIndex: params.targetIndex }
                  : {
                      isDragging: true,
                      oldIndex: params.oldIndex,
                      targetIndex: params.targetIndex
                    };
              }}
              onColumnWidthChange={handleColumnResize}
              density={"compact"}
              loading={!(apidata && apidata.out)}
              rows={filteredRowData}
              columns={getSortedColumns()}
            />
          </div>
        </div>
      </ResponsiveDrawer>
      <PageInPage
        onClose={() => {
          refreshRequest(showReco.customer_num);
          setShowReco({});
        }}
        title={`Reconfiguration for ${showReco.sales_office}: ${showReco.customer_num} 
        ${showReco.name1} [${showReco.name3}]`}
        isOpen={Object.values(showReco).length > 0}
        content={<RecommendationComponent fullpage={false} customer={showReco.customer_num} />}
      />
      <PageInPage
        onClose={() => {
          refreshRequest((showTicket && showTicket.customerNum) || "");
          setShowTicket(undefined);
        }}
        title={`${showTicket ? showTicket.salesOffice : ""} (${showTicket ? showTicket.customerNum : ""}) ${
          showTicket ? showTicket.customerName : ""
        }`}
        isOpen={showTicket ? true : false}
        content={
          <VendPrimeRequest
            requestNum={showTicket ? showTicket.requestNum : 0}
            onClose={() => {
              setShowTicket(undefined);
            }}
          />
        }
      />
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={showLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
}
